module.exports = __webpack_public_path__ + "img/00049.58b01850.webp";